import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

export class AppBody extends Component {
  static displayName = AppBody.name;

  render () {
    return (
      <div>
        <NavMenu />
            <Container>

          {this.props.children}
        </Container>
      </div>
    );
  }
}
